"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFab = void 0;
var palette_1 = require("../../global/palette");
var shadows_1 = require("../../global/shadows");
var typography_1 = require("../../global/typography");
exports.MuiFab = {
    root: {
        '& .MuiBadge-root': {
            marginRight: 18,
        },
        '& svg:not(.MuiBadge-root svg)': {
            marginLeft: 27,
        },
        boxShadow: shadows_1.boxShadow.large,
    },
    extended: {
        padding: "12px 24px",
        minHeight: 54,
        borderRadius: 50,
    },
    label: __assign(__assign({}, typography_1.typography.h6), { fontSize: typography_1.typography.pxToRem(15) }),
    primary: {
        '&:hover': {
            backgroundColor: palette_1.palette.primary.light,
        },
        '&:active': {
            backgroundColor: palette_1.palette.primary.dark,
        },
        '&:focus-visible': {
            backgroundColor: palette_1.palette.primary.dark,
        },
    },
};
